import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Plus, Users } from 'lucide-react';

const TrialCustomerRegistrationModal = ({ onClose, onRegister }) => {
    // 모달이 열릴 때 배경 스크롤 비활성화
    useEffect(() => {
        const scrollY = window.scrollY;
        document.body.style.position = 'fixed';
        document.body.style.top = `-${scrollY}px`;
        document.body.style.width = '100%';
        document.body.style.overflow = 'hidden';

        // cleanup 함수: 컴포넌트가 언마운트될 때 스크롤 복원
        return () => {
            const scrollY = document.body.style.top;
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.width = '';
            document.body.style.overflow = '';
            if (scrollY) {
                window.scrollTo(0, parseInt(scrollY || '0') * -1);
            }
        };
    }, []);

    const handleRegister = () => {
        onRegister && onRegister();
        onClose && onClose();
    };

    return (
        <AnimatePresence>
            <motion.div
                className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                onClick={onClose}
            >
                <motion.div
                    className="bg-white rounded-2xl shadow-2xl max-w-lg w-full p-6 md:p-8 relative"
                    initial={{ scale: 0.9, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    exit={{ scale: 0.9, opacity: 0 }}
                    onClick={(e) => e.stopPropagation()}
                >
                    {/* 닫기 버튼 */}
                    <button
                        onClick={onClose}
                        className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
                    >
                        <X className="w-5 h-5" />
                    </button>

                    {/* 아이콘 */}
                    <div className="flex justify-center mb-4">
                        <div className="w-16 h-16 rounded-full bg-blue-100 flex items-center justify-center">
                            <Users className="w-8 h-8 text-blue-600" />
                        </div>
                    </div>

                    {/* 제목 */}
                    <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4 text-center pr-8">
                        첫 고객을 등록해보세요!
                    </h2>

                    {/* 내용 */}
                    <div className="space-y-4 text-gray-700">
                        <p className="text-base md:text-lg leading-relaxed text-center">
                            고객을 등록하면 더 효과적으로 고객 관리를 시작할 수 있습니다.
                        </p>

                        <ol className="space-y-3 text-sm md:text-base">
                            <li className="flex items-start gap-3">
                                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-blue-100 text-blue-700 font-bold flex items-center justify-center text-xs">
                                    1
                                </span>
                                <span className="pt-0.5">
                                    오른쪽 아래 <strong className="text-gray-900">보라색 + 버튼</strong>을 눌러 고객을 추가하세요.
                                </span>
                            </li>
                            <li className="flex items-start gap-3">
                                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-blue-100 text-blue-700 font-bold flex items-center justify-center text-xs">
                                    2
                                </span>
                                <span className="pt-0.5">
                                    고객 정보를 입력하면 <strong className="text-gray-900">단계별로 관리</strong>할 수 있습니다.
                                </span>
                            </li>
                            <li className="flex items-start gap-3">
                                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-blue-100 text-blue-700 font-bold flex items-center justify-center text-xs">
                                    3
                                </span>
                                <span className="pt-0.5">
                                    상담 기록, 생일, Follow Up 등을 기록하여 <strong className="text-gray-900">체계적으로 관리</strong>하세요.
                                </span>
                            </li>
                        </ol>
                    </div>

                    {/* 버튼 영역 */}
                    <div className="mt-8 flex flex-col sm:flex-row justify-end gap-3">
                        <button
                            onClick={onClose}
                            className="px-6 py-2.5 bg-gray-200 hover:bg-gray-300 text-gray-800 font-semibold rounded-lg transition-colors"
                        >
                            나중에
                        </button>
                        <button
                            onClick={handleRegister}
                            className="px-6 py-2.5 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-semibold rounded-lg transition-all shadow-lg hover:shadow-xl flex items-center justify-center gap-2"
                        >
                            <Plus className="w-5 h-5" />
                            고객 등록하기
                        </button>
                    </div>
                </motion.div>
            </motion.div>
        </AnimatePresence>
    );
};

export default TrialCustomerRegistrationModal;

